import yup from 'yup'

export const email = yup
  .string()
  .email('Email must be a valid email address')
  .required("Email can't be blank")

export const password = yup
  .string()
  .required("Password can't be blank")
  .min(8, 'Password is too short (minimum is 8 characters)')
  .matches(/\d/, 'Password must contain a digit')
  .matches(/[A-Z]/, 'Password must contain an uppercase character')
  .matches(/[a-z]/, 'Password must contain a lowercase character')
  .matches(/[^a-zA-Z\d]/, 'Password must contain a special character')

export const passwordConfirmation = yup
  .string()
  .when('password', (password, schema) =>
    schema.test(
      'passwordMatches',
      "Password confirmation doesn't match password",
      passwordConfirmation => passwordConfirmation === password
    )
  )



// WEBPACK FOOTER //
// ./src/utils/validations.js